import { getGlobals } from "storyblok/api"
import { getAllWinAndReviewCategoriesPaths, getCategoryArchiveWinsAndReviews, getWinAndReviewsCategories } from "storyblok/winsAndReviews"
import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import PageHeader from "components/DynamicComponent/molecules/PageHeader"
import WinsAndReviewCard from "components/WinsAndReviewCard"
import Meta from "components/Meta"
import { getCategoryArchiveWinsAndReviewsApi } from "storyblok/winsAndReviewsApi"
import { CardListSection } from "components/Archive/CardListSection"

export default function WinsAndReviewsCategoryArchive({ category, items, categories, total, perPage, currentPage }) {
  return (
    <>
      <Meta
        info={{
          title: `${category.name}`,
          og_title: `${category.name}`,
          twitter_title: `${category.name}`,
        }}
      />
      <main data-pagefind-ignore="all">
        <PageHeader
          blok={{
            type: "standard",
            heading: category.name,
            breadcrumbs: [{ text: "Wins & Reviews", href: "/wins-and-reviews" }, { text: category.name }],
          }}
        />
        <CategoryArchiveSection
          categories={categories}
          archiveLink="/wins-and-reviews"
          categoryLinkPrefix="/wins-and-reviews/category/"
          currentTab={category}
          list={<CardListSection
            key={category.value}
            items={items}
            total={total}
            perPage={perPage}
            currentPage={currentPage}
            columns={3}
            backgroundColor="highlight-tint"
            category={category.value == 'all' ? undefined : category.value.replaceAll("-", "_")}
            handler={(params) => getCategoryArchiveWinsAndReviewsApi(params)}
            Card={WinsAndReviewCard} />}
        />
      </main>
    </>
  )
}

export async function getStaticProps({ params: { category } }) {
  const globals = await getGlobals("exclude-global-sections")
  const categories = await getWinAndReviewsCategories()
  const { items, total, perPage, currentPage } = await getCategoryArchiveWinsAndReviews({
    category: category.replaceAll("-", "_"),
  })

  return {
    props: {
      category: categories.find((cat) => cat.value === category),
      items: items ?? null,
      categories: categories ?? null,
      globals: globals ?? null,
      total,
      perPage,
      currentPage
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: getAllWinAndReviewCategoriesPaths(),
    fallback: false,
  }
}
